// Credit to https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
export const popupCenter = (url: string, title: string, w: number, h: number) => {
    // Fixes dual-screen position                         Most browsers      Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    /*eslint-disable */
    const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement?.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
    const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement?.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

    /*eslint-enable */

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;

    const newWindow = window.open(
        url,
        title,
        `
            htoolbar=no,
            resizable=yes,
            location=no,
            status=no,
            menubar=no,
            scrollbars=no,
            width=${w},
            height=${h},
            top=${top},
            left=${left}
        `
    );

    // Puts focus on the newWindow
    if (window.focus) {
        newWindow.focus();
    }
};
